{
  "button-bar-for-selected-service": {
    "text": {
      "and-x-more": "a {{nr}} více",
      "duration": "Doba trvání",
      "select-service-hint": "Pro pokračování vyberte alespoň jednu službu a požadovaný čas."
    }
  }
}
